export default "__VITE_ASSET__PeqhMBTi__"